import type { PropsWithChildren } from "react";
import { useWorkspaceNavigationSections } from "@/components/sidebar/workspace-sidebar-items";
import { useWorkspaceAdmin } from "@/hooks/use-workspace-admin";
import type { WorkspaceTab } from "@/lib/schema";
import { Layout } from "./layout";
import { WorkspaceNoAccessState } from "./workspace/workspace-no-access-state";

// Sole access gate for the Workspace Admin routes (UNB-2694): renders the real page only once
// the user is confirmed as a Workspace Admin of the `$workspaceId` in the URL, otherwise
// the no-access empty state — same chrome (sidebar) either way, and the same state for a
// workspace that doesn't exist as for one the user just isn't a member of.
export const WorkspaceLayout = ({ page, children }: { page: WorkspaceTab } & PropsWithChildren) => {
  const { isLoading, workspace, isWorkspaceAdmin } = useWorkspaceAdmin();
  const sections = useWorkspaceNavigationSections();
  const hasAccess = !isLoading && !!workspace && isWorkspaceAdmin;

  return (
    <Layout activeTab={page} sections={sections}>
      {isLoading ? null : hasAccess ? children : <WorkspaceNoAccessState />}
    </Layout>
  );
};
